import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../apis/axiosConfig';

const AcceptInvite = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const acceptInvitation = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.post('/org/members/accept_invite/', {
          token: token
        });
        
        setMessage(response.data?.detail || 'Invitation accepted successfully!');
        setError('');
        
        // Redirect to dashboard after 2 seconds
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } catch (err) {
        console.error('Failed to accept invitation:', err);
        setError(
          err.response?.data?.detail || 
          err.response?.data?.error || 
          'Failed to accept invitation. The link may be expired or invalid.'
        );
        setMessage('');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      acceptInvitation();
    } else {
      setError('Invalid invitation link');
      setLoading(false);
    }
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        {loading ? (
          <>
            <div className="mb-6">
              <div className="w-20 h-20 mx-auto relative">
                <div className="absolute inset-0 border-4 border-[#008300] rounded-full animate-spin" style={{ borderTopColor: '#3b82f6' }}></div>
              </div>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Processing Invitation</h2>
            <p className="text-gray-600">Please wait...</p>
          </>
        ) : error ? (
          <>
            <div className="text-6xl mb-4">⚠️</div>
            <h2 className="text-2xl font-bold text-red-600 mb-4">Invitation Error</h2>
            <p className="text-gray-700 mb-6">{error}</p>
            <button
              onClick={() => navigate('/signin')}
              className="bg-[#008300] text-white px-6 py-3 rounded-lg hover:bg-green-700 transition"
            >
              Go to Sign In
            </button>
          </>
        ) : (
          <>
            <div className="text-6xl mb-4">✅</div>
            <h2 className="text-2xl font-bold text-green-600 mb-4">Success!</h2>
            <p className="text-gray-700 mb-6">{message}</p>
            <p className="text-sm text-gray-500">Redirecting to dashboard...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptInvite;
